<dialog-wrapper
  #wrapper
  [backgroundColor]="'#41474f'"
  [dialogTitle]="'ADD ITEM'"
  [smallTitle]="true"
  [giveMeTwenty]="true"
  [titleHeight]="40"
  [maxHeight]="maxHeight"
  [hideBottom]="true"
  [showClose]="true"
  (close)="close()">
    <div class="line-items">
      <div class="item" *ngFor="let item of account?.lineItems" (click)="dialogRef.close(item)">
        <div class="sort">{{ item.sortNumber }}</div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
    <div class="label" *ngIf="!!account" (click)="openAddItem($event)">
      + ADD NEW ITEM 
    </div>
</dialog-wrapper>
